import EventDTO from '../models/event';

/**
 * Si el evento puede venderse con el checkout nuevo. Funciones, descuentos por
 * público y el checkout rápido ya van por el nuevo. Los casos que todavía no
 * cubre (precio libre, entradas para socios, solo pago manual) siguen con el
 * checkout actual: mejor el flujo de siempre que uno a medias.
 */
const isCheckoutV2Eligible = (event: EventDTO): boolean => {
  // El checkout nuevo cobra con estas pasarelas. Un evento sin ninguna (solo
  // pago manual por WhatsApp, o Ualá) llegaba a Pago sin medios para pagar:
  // sigue con el checkout de siempre.
  const hasOnlineGateway = event.allow_zilo_payments || event.allow_nave_payments || event.allow_payway_payments
    || event.allow_payway_link_payments || event.allow_fiserv_payments || event.allow_mercadopago_payments
    || event.allow_stripe_payments;
  // Un evento con todas las entradas gratis no necesita pasarela.
  const tickets = event.tickets ?? [];
  const allFree = tickets.length > 0 && tickets.every((ticket) => Number(ticket.price) === 0);
  if (!hasOnlineGateway && !allFree) {
    return false;
  }
  return !tickets.some((ticket) => ticket.has_open_price || ticket.is_member_exclusive);
};

export default isCheckoutV2Eligible;
